<template>
    <nav id="main-nav" class="uk-navbar">
        <a
            v-if="!!profile_id"
            href
            class="uk-navbar-toggle uk-visible-small"
            @click.prevent.stop="toggle_navigation"
        ></a>
        <router-link to="/" class="uk-navbar-brand">
            <span v-if="$root.applicationLogo"><img :src="$root.applicationLogo" :alt="$root.applicationName"></span>
            <span v-if="!$root.applicationLogo">{{ $root.applicationName }}</span>
        </router-link>
        <div
            :class="{ 'uk-active': navigating }"
            class="nibnut-menu-holder"
        >
            <nav-menu
                class="uk-navbar-nav"
                position="left"
                @new-project="$emit('new-project', $event)"
                @new-contact="$emit('new-contact', $event)"
                @new-user="$emit('new-user', $event)"
            />
        </div>
        <div class="uk-navbar-flip">
            <nav-menu
                class="uk-navbar-nav"
                position="right"
                @new-project="$emit('new-project', $event)"
                @new-contact="$emit('new-contact', $event)"
                @new-user="$emit('new-user', $event)"
            />
        </div>
    </nav>
</template>

<script>
import profile_utilities from "./mixins/ProfileUtilities"
import string_utilities from "./mixins/StringUtilities"

import NavMenu from "./ui/NavMenu.vue"

export default {
    mixins: [profile_utilities, string_utilities],
    watch: {
        $route: "stop_navigating"
    },
    methods: {
        logout () {
            this.$store.dispatch("LOGOUT")
        },
        toggle_navigation () {
            this.navigating = !this.navigating
        },
        stop_navigating () {
            this.navigating = false
        }
    },
    components: {
        NavMenu
    },
    props: {
        isPublicPage: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            message_countdown: 0,
            navigating: false
        }
    }
}
</script>
